module.exports = __webpack_public_path__ + "static/media/6_nouana_a.49bacc6b.ogg";